export default "__VITE_ASSET__IBuLXJHy__"